import { render, staticRenderFns } from "./MaterialsTasksToolbar.vue?vue&type=template&id=612e166a"
import script from "./MaterialsTasksToolbar.vue?vue&type=script&lang=js"
export * from "./MaterialsTasksToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports